export const aboutLanding4 = {
  hero: {
    title: "Building modern\ninfrastructure for\nEuropean businesses.",
    description:
      "A product company on a mission to simplify how service businesses launch, sell, and grow online.",
  },
  mission: {
    badge: "OUR MISSION",
    text: "Millions of talented professionals, coaches, trainers, therapists, creators, struggle with the technology of running their business online. They're forced to stitch together tools that were never designed to work together.",
    text2:
      "Bespire exists to change that. We're building an AI-native platform that gives every service professional the digital infrastructure they need: unified, intelligent, and beautifully simple.",
    quote:
      '"If you\'re great at what you do, technology should make building a business around it easier."',
  },
  beliefs: {
    title: "What we\nbelieve.",
    items: {
      productFirst: {
        title: "Product-first",
        description:
          "We build tools that solve real problems: not features for pitch decks.",
      },
      europeanFirst: {
        title: "European-first",
        description:
          "Designed for European business culture, privacy standards, and payment ecosystems.",
      },
      trustThroughQuality: {
        title: "Trust through quality",
        description:
          "We earn trust by shipping polished, reliable software: not through hype.",
      },
      forRealBusinesses: {
        title: "For real businesses",
        description:
          "Everything we build serves people who do meaningful work.",
      },
    },
  },
  approach: {
    badge: "OUR APPROACH",
    text: "Great software should be opinionated, not overwhelming. Our platform makes smart decisions by default while giving you full control to customise.",
    text2:
      "We design for European businesses first: considering local payment methods, privacy expectations, and cultural nuances that global platforms overlook.",
  },
  cta: {
    title: "Join us on the journey.",
    description:
      "We're building the future of business infrastructure for service professionals. Be part of it.",
    demoButton: "Book 30 minutes",
    earlyAccessButton: "Start today",
  },
  finalCta: {
    title: "Ready to join?",
    description:
      "Bespire is available now. Launch your site in 10 minutes, or talk to us about us setting it up for you.",
    startButton: "Start now: free",
    callButton: "Book 30 minutes",
    footnote: "No credit card · 3 days full access · European support",
  },
  footer: {
    description:
      "The AI-native business platform for European service professionals.",
    demoButton: "Book 30 minutes",
    platform: "PLATFORM",
    product: "Product",
    useCases: "Use Cases",
    company: "COMPANY",
    about: "About",
    contact: "Contact",
    legal: "LEGAL",
    privacy: "Privacy",
    terms: "Terms",
    imprint: "Imprint",
    copyright: "© {year} BESPIRE",
    builtInEurope: "BUILT IN EUROPE",
  },
};
